<template>
    <card class="card">
      <!-- respondido ou fora do periodo de repostas -->
        <div class="card-body" v-if="isAnswered || !isOpened">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-file-alt text-primary"></i> Responder Questionário
            </h2>
            <hr />
            <div class="row">
                <div class="col-md-12">
                  <h4 class="mt-0">{{ assessments.title }}</h4>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-12">
                  {{ assessments.description }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                  <h5>Data de início:</h5>
                  {{ assessments.start_date | moment("DD/MM/YYYY") }}
                </div>
                <div class="col-md-6">
                  <h5>Data de encerramento:</h5>
                  {{ assessments.end_date | moment("DD/MM/YYYY") }}
                </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <h4 v-if="!isOpened">Questionário fora de período para o recebimento de respostas.</h4>
                <h4 v-if="isAnswered">Questionário já respondido.</h4>
              </div>
            </div>
            <div class="clearfix"></div>
        </div>

        <!-- liberado para responder -->
        <div class="card-body" v-if="!isAnswered && isOpened">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-file-alt text-primary"></i> Responder Questionário
            </h2>
            <hr />
            <div class="row">
                <div class="col-md-12">
                  <h4 class="mt-0">{{ assessments.title }}</h4>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-12">
                  {{ assessments.description }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                  <h5>Data de início:</h5>
                  {{ assessments.start_date | moment("DD/MM/YYYY") }}
                </div>
                <div class="col-md-6">
                  <h5>Data de encerramento:</h5>
                  {{ assessments.end_date | moment("DD/MM/YYYY") }}
                </div>
            </div>
            <hr />
            <div class="row mt-5">
              <div class="col-md-12">
                <h3 class="pt-0 mt-0">
                    <i class="fas fa-question text-primary"></i> Questões
                  </h3>
              </div>
            </div>
            <!-- Perguntas -->
            <assessment-question v-model="assessments.questions" :immediateWatch="true" />
            
            <div class="text-left">
                <p-button type="primary" @click.native.prevent="save">Responder</p-button>
            </div>
            <div class="clearfix"></div>
        </div>
    </card>
</template>
<script>
import Multiselect from "vue-multiselect";
import deepmerge from "deepmerge";
import { mapState } from "vuex";
import AssessmentQuestion from "./components/AssessmentQuestion";

export default {
  components: {
    AssessmentQuestion
  },
  data() {
    return {
      form: {
        asf_id: this.$store.getters["auth/getCurrentAsf"],
        assessment: {
          id: "",
          title: "",
          description: "",
          start_date: "",
          end_date: "",
          questions: []
        }
      },
    };
  },
  computed: {
    ...mapState("assessments", {
      assessments: "assessments"
    }),
    ...mapState("assessments", {
      answers: "answers"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    isAnswered(){
      // prepare array with answered asssessments ids
      if(this.isAdmin === false){
        this.assessments_ids = [];
        this.answers.forEach((item) => {
          this.assessments_ids.push(item.assessment_id);
        });
        
        return this.assessments_ids.includes(this.form.assessment.id);
      }
      return false;
    },
    isOpened(){
      return (
        this.$moment(new Date()).isAfter(this.form.assessment.start_date) && 
        this.$moment(new Date()).isBefore(this.form.assessment.end_date)
      );
    },
  },
  watch: {
    assessments: function(newData) {
      // console.log("teste");
      this.form.assessment = deepmerge(this.form.assessment, newData, {
        arrayMerge: (destination, source) => {
          return [...destination, ...source];
        }
      });
    },
  },
  created() {
    // pega assessments
    this.$store
      .dispatch("assessments/get", this.$route.params.id)
      .catch(error => {
        let msg = "";
        if (error.response.data) {
          msg = error.response.data.errors[0].detail;
        } else {
          msg = error.response.message;
        }
        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: msg
        });
      });

    if(this.isAdmin === false){
      // pega respostas se nao for admin
      this.$store
        .dispatch("assessments/getAnswers", this.form.asf_id)
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  },
  methods: {
    save() {
      // console.log(this.form);
      this.$store
        .dispatch("assessments/answer", this.form)
        .then(response => {
          this.$router.push({ name: "assessments" });
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: "Assessment sent with success!"
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
